import { IServerSideGetRowsParams } from 'ag-grid-community';
import { Injectable } from '@angular/core';
import {
  Direction,
  ResultSort,
} from '@compumark/analyst-selection-tool-client';

@Injectable({
  providedIn: 'root',
})
export class ResultSortService {
  private readonly normalizationMapping: Readonly<Record<string, string>> = {
    trademark: 'normalizedTrademark',
    analystName: 'normalizedAnalyst',
  };

  constructor() {}

  getSortModel(params: IServerSideGetRowsParams): Array<ResultSort> {
    return (
      params.request?.sortModel.map((sortModel) => {
        const field = this.getNormalizedField(sortModel.colId);
        return {
          field,
          direction: sortModel.sort === 'asc' ? Direction.ASC : Direction.DESC,
        };
      }) ?? []
    );
  }

  private getNormalizedField(field: string): string {
    return this.normalizationMapping[field] ?? field;
  }
}
